import { useState, type FormEvent } from 'react';
import { usePlatformAuth } from './PlatformAuthProvider';

export default function LoginScreen() {
  const { login } = usePlatformAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setLoading(true); setError('');
    try {
      await login(username.trim(), password);
    } catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(160deg, #1E293B, #334155)',
      padding: 16, boxSizing: 'border-box',
    }}>
      <div className="card fade-in" style={{ width: '100%', maxWidth: 380, padding: 32, boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 6 }}>🛠</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>ClintoBytes Platform Console</div>
          <div style={{ fontSize: 11, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '1px', marginTop: 2 }}>
            Internal — tenant provisioning &amp; management
          </div>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom: 14 }}>
            <label className="lbl">Operator username</label>
            <input value={username} onChange={e => setUsername(e.target.value)} autoFocus placeholder="e.g. operator" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="lbl">Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" />
          </div>

          {error && (
            <div style={{ padding: '8px 12px', background: '#FEE2E2', border: '1px solid #FECACA', borderRadius: 'var(--radius)', color: '#991B1B', fontSize: 13, marginBottom: 14 }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading || !username.trim() || !password}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
